/*
         * @ngdoc function
         * @name ePay.WebApi:Session_ePaySessionWebApi
         * @description
         * Web Api Service
         */
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { Session_ePaySessionModel } from '../../Models/Model/Session_ePaySessionModel';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})

export class Session_ePaySessionWebApi {
	constructor(private http: HttpClient) { }


	refresh(groupid?: string, config?: string) {
		let _formdata = new FormData();
		let headers = new HttpHeaders();
		headers.append('Content-Type', 'application/json');
		let urlParams = new HttpParams();
		if (groupid !== null && typeof groupid !== 'undefined')
		{
			urlParams = urlParams.append('groupid', groupid.toString());
		}
		if (config !== null && typeof config !== 'undefined')
		{
			urlParams = urlParams.append('config', config.toString());
		}
		return this.http.post<Session_ePaySessionModel>('/api/Session_ePaySession/Refresh', _formdata, {headers: headers, params: urlParams})
	}


	getNextPage(session_ePaySessionModel: Session_ePaySessionModel) {
		let headers = new HttpHeaders();
		let urlParams = new HttpParams();
		headers.append('Content-Type', 'application/json');
		return this.http.post<Session_ePaySessionModel>('/api/Session_ePaySession/GetNextPage', session_ePaySessionModel, {headers: headers, params: urlParams})
	}


	caclulateAmount(session_ePaySessionModel: Session_ePaySessionModel) {
		let headers = new HttpHeaders();
		let urlParams = new HttpParams();
		headers.append('Content-Type', 'application/json');
		return this.http.post<Session_ePaySessionModel>('/api/Session_ePaySession/CaclulateAmount', session_ePaySessionModel, {headers: headers, params: urlParams})
	}


	unStore(session_ePaySessionModel: Session_ePaySessionModel) {
		let headers = new HttpHeaders();
		let urlParams = new HttpParams();
		headers.append('Content-Type', 'application/json');
		return this.http.post<Session_ePaySessionModel>('/api/Session_ePaySession/UnStore', session_ePaySessionModel, {headers: headers, params: urlParams})
	}


	sendAuthPayment(session_ePaySessionModel: Session_ePaySessionModel) {
		let headers = new HttpHeaders();
		let urlParams = new HttpParams();
		headers.append('Content-Type', 'application/json');
		return this.http.post<Session_ePaySessionModel>('/api/Session_ePaySession/SendAuthPayment', session_ePaySessionModel, {headers: headers, params: urlParams})
	}


	sendPayment(session_ePaySessionModel: Session_ePaySessionModel) {
		let headers = new HttpHeaders();
		let urlParams = new HttpParams();
		headers.append('Content-Type', 'application/json');
		return this.http.post<Session_ePaySessionModel>('/api/Session_ePaySession/SendPayment', session_ePaySessionModel, {headers: headers, params: urlParams})
	}


	postApplePay(session_ePaySessionModel: Session_ePaySessionModel) {
		let headers = new HttpHeaders();
		let urlParams = new HttpParams();
		headers.append('Content-Type', 'application/json');
		return this.http.post<Session_ePaySessionModel>('/api/Session_ePaySession/PostApplePay', session_ePaySessionModel, {headers: headers, params: urlParams})
	}

  postGooglePay(session_ePaySessionModel: Session_ePaySessionModel) {
    let headers = new HttpHeaders();
    let urlParams = new HttpParams();
    headers.append('Content-Type', 'application/json');
    return this.http.post<Session_ePaySessionModel>('/api/Session_ePaySession/PostGooglePay', session_ePaySessionModel, { headers: headers, params: urlParams })
  }

  generateRequestId(session_ePaySessionModel: Session_ePaySessionModel) {
    let headers = new HttpHeaders();
    let urlParams = new HttpParams();
    headers.append('Content-Type', 'application/json');
    return this.http.post<string>('/api/Session_ePaySession/GenerateRequestId', session_ePaySessionModel, { headers: headers, params: urlParams })
  }



}
